import OpenAIClient from "@/openai/OpenAIClient.js";

export default {
  GetTextOnly(richText){
    var div = document.createElement("div");
    div.innerHTML = richText;
    return div.innerText;
  },
  GenerateQuestions(arrTopicsToGenerateQuestionsFor, identifier) {
    var instance = this;

    return new Promise(function (resolve, reject) {

      if (!arrTopicsToGenerateQuestionsFor[0].Description || arrTopicsToGenerateQuestionsFor[0].Description.length == 0) {
        throw "No description";
      }

      var questions = arrTopicsToGenerateQuestionsFor.map((itm) => ({
        title: itm.Title,
        description: instance.GetTextOnly(itm.Description),
        id: itm.Id,
      }));

      var responseFormat = [
        {
          t: "Question title", // Question text.
          tid: "", // The ID property for the coresponding item. Required!.
          a: [
            // Answers
            {
              t: "Answer 1 text", // Answer text
              c: true, // true if this is the correct answer, false itherwise.
            },
            // 2 more answers.
          ],
        }
      ];

      var prompt =
        "I am providing a JSON template and a few articles. USE THE SAME LANGUAGE AS THE ARTICLE! I need to get back between 2 and 10 questions per article (depending on the length) in the provided JSON format. NOTHING ADDITIONAL, just as if you are a JSON SERVER. Avoid asking questions that involved memorizing long strings, numbers, DNA sequences, and anything of this sort. We're not testing memory here. Here is your JSON Template:" +
        JSON.stringify(responseFormat) +
        "\n\n Make sure to put the id of the question in the tid property in the template! Ensure you provide only valid JSON AS A RESPONSE NO ADDITIONAL TEXT! BE AS BRIEF AS POSSIBLE!  DO NOT RETURN COMMENTS IN THE JSON. I need 3 possible answers, ONLY 1 answer can be correct. MAKE SURE TO RANDOMIZE QUESTIONS AND THE CORRECT ANSWER POSITION. TRY TO MAKE ANSWERS ABOUT THE SAME LENGTH. IF YOU CAN'T GENERATE - RETURN {\"Error\":\"Reason\"} Here are the articles:" +
        JSON.stringify(questions);

      var itemToPromptFor = "DataModel.TCVelik.Embed.TCEmbed_" + identifier;

      OpenAIClient.promptRaw(prompt, itemToPromptFor, true).then(function (response) {
        var aiResponse = response.data;
        try {
          var JSONWrapperObj = JSON.parse(aiResponse);
          var descriptionFinal = JSONWrapperObj.choices[0].message.content;

          try {
            var result = JSON.parse(descriptionFinal);

            result = result.map(function (question) {
              question.hidden = false;
              var answers = question.a.map(function (answer) {
                answer.hidden = false;
                return answer;
              });
              question.a = answers;
              return question;
            });

            resolve(result);

          } catch (err) {
            reject(err);
            console.error(err);
          }
        } catch (err2) {
          console.error(err2);
          reject(err2);
        }
      });
    });
  }
}
